import React, {useEffect} from 'react';
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSchool, faUserGraduate, faChalkboardTeacher, faNewspaper } from '@fortawesome/free-solid-svg-icons'

export default function Home() {

  useEffect(() => {
    document.title = "Cool Kids English - Teachers"
  }, []);

  const renderTeacher = (teacher) => {
    return (
      <div style={{marginBottom: 20}}>
        <h2>{teacher.name}</h2>
        <div style={{display: 'flex', padding: 10}}><img className="bioimage" src={teacher.image}/><p style={{flex: 1, margin: 10}}>{teacher.bio}</p></div>
      </div>
    )
  }
  return(
    <div>
      <h1>Meet the Teachers</h1>
      {renderTeacher({ name: 'Jim', image: require('../../images/jim.png').default, bio: `Jim's Bio is coming soon!`})}
      {renderTeacher({ name: 'Dan', image: require('../../images/dan.png').default, bio: `Dan's Bio is coming soon!`})}
      {renderTeacher({ name: 'Maria', image: require('../../images/maria.png').default, bio: `Maria's Bio is coming soon!`})}
      {renderTeacher({ name: 'Corey', image: require('../../images/corey.png').default, bio: `Corey's Bio is coming soon!`})}
    </div>
  )
}
